import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { showErrorToast } from '../../../../../../common/global/helpers';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { resources } from '../../../../resources/resources';
import { employeeFilesService } from '../../../../services/employee-files';

export default function DownloadFromLinkPage() {
  const auth = useAuth();
  const mavigate = useNavigate();
  const { customerInfo } = useContext(CustomerInfoContext);
  const { t: translate } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search);
  const archiveId = queryParams.get('archiveId');
  const fileDownloadName = queryParams.get('fileDownloadName');

  useEffect(() => {
    let isCancelled = false;
    const handleDownloadFiles = async () => {
      if (isCancelled) {
        return;
      }

      if (
        !archiveId ||
        !fileDownloadName ||
        !auth.isAuthenticated ||
        !customerInfo.isPowerUser
      ) {
        return;
      }

      const response = await employeeFilesService.downloadEmployeesFiles(
        archiveId,
        fileDownloadName,
      );

      if (!response.hasErrors) {
        mavigate('/admin/employee-files');
      } else {
        showErrorToast(
          translate(resources.admin.fileImport.validation.genericError),
        );
        mavigate('/admin/employee-files');
      }
    };
    handleDownloadFiles();
    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <LoadingSpinner size="medium" />;
}
